/**
 * Common styling constants and utilities
 */

/**
 * CAN bus source styling utilities
 */
export const CAN_BUS_STYLES = {
  // Colors for CAN bus indicators (matching legacy dashboard)
  color: '#007bff',
  badgeColor: '#007bff',
  textColor: '#007bff',
  // Badge styling for tile headers
  badge: {
    fontSize: '0.65rem',
    padding: '0.35em 0.5em',
    fontWeight: '500',
    borderRadius: '0.25rem',
  },
  
  // Chart subtitle styling
  subtitle: {
    fontSize: '11px',
    color: '#007bff',
    fontWeight: 'bold',
  },
}

/**
 * Card styling presets for consistent card appearance
 */
export const CARD_STYLES = {
  // Base styling for all cards
  base: {
    transition: 'all 0.3s ease',
    marginBottom: '1rem',
  },
  
  // Main cards
  primary: {
    className: 'card shadow-sm border-0 mb-4',
    style: { 
      background: 'linear-gradient(to right, #ffffff, #f8f9fa)',
      transition: 'all 0.3s ease',
    },
  },
  
  // Sub-cards for sections
  secondary: {
    className: 'card border-0 mb-3',
    style: {
      border: '2px solid #28a745 !important',
    },
  },
  
  // Alternating sub-card styles
  subCardPrimary: {
    className: 'card border-0 mb-3',
    style: { 
      background: 'linear-gradient(to right, #e8f5e8, #f0f8f0)',
      border: '2px solid #28a745 !important',
    },
  },
  
  subCardSecondary: {
    className: 'card border-0 mb-3', 
    style: { 
      background: 'linear-gradient(to right, #fff3cd, #fdf6e3)',
      border: '2px solid #ffc107 !important',
    },
  },
}

/**
 * Card header styling
 */
export const CARD_HEADER_STYLES = {
  primary: {
    className: 'card-header fw-bold border-0',
  },
  
  subCard: (color = '#28a745') => ({
    className: 'card-header fw-bold',
    style: { 
      background: 'transparent', 
      borderBottom: `1px solid ${color}`,
    },
  }),
}

/**
 * Status color mapping
 */
export const STATUS_COLORS = {
  success: '#28a745',
  warning: '#ffc107', 
  error: '#dc3545',
  loading: '#6c757d',
  info: '#17a2b8',
}

/**
 * Icon mappings for different contexts
 */
export const CONTEXT_ICONS = {
  alternator: 'bi-lightning-charge-fill',
  battery: 'bi-battery-full',
  network: 'bi-wifi',
  import: 'bi-download',
  export: 'bi-upload',
  dashboard: 'bi-speedometer2',
  configuration: 'bi-gear-fill',
  analysis: 'bi-graph-up',
}

/**
 * Common spacing utilities
 */
export const SPACING = {
  xs: '0.25rem',
  sm: '0.5rem', 
  md: '1rem',
  lg: '1.5rem',
  xl: '2rem',
  xxl: '3rem',
}

/**
 * Helper function to get sub-card styling based on index
 */
export const getSubCardStyle = (index) => {
  return index === 0 ? CARD_STYLES.subCardPrimary : CARD_STYLES.subCardSecondary
}

/**
 * Helper function to get icon color based on index
 */
export const getSubCardIconColor = (index) => {
  return index === 0 ? 'text-success' : 'text-warning'
}

/**
 * Helper function to get border color based on index
 */
export const getSubCardBorderColor = (index) => {
  return index === 0 ? '#28a745' : '#ffc107'
}
